type AppConfig = {
  // Intake BE(spnp) 요청 기준 URL. 개발은 같은 origin의 Vite 프록시를 사용한다.
  apiBaseUrl: string;
  /** 클라이언트에 안내할 공개 MCP 주소. 로컬 게이트웨이는 별도 주소를 지정한다. */
  mcpUrl: string;
  // Overlord(인증 서버) 공개 URL. Intake BE 와 별도 Deployment 라 apiBaseUrl 에서 파생하지 않는다.
  authBaseUrl: string;
  // 개발 환경 표준 지연 주입(rules.md §7). null이면 어떤 요청에도 지연을 넣지 않는다.
  simulatedLatencyMs: number | null;
  // 이 번들의 빌드 식별자(`g<sha>`). 배포된 `build-info.json` 과 대조해 번들이 낡았는지 안다.
  buildId: string;
};

// 미국 <-> 한국/동남아 round-trip 표준(약 200ms ~ 300ms)의 중앙값을 기본 지연으로 둔다.
const STANDARD_LATENCY_MS = 250;

export const appConfig: AppConfig = {
  // 개발에서는 Vite가 VITE_API_BASE_URL로 전달하므로 브라우저의 CORS 왕복을 만들지 않는다.
  apiBaseUrl: import.meta.env.DEV ? "" : normalizeBaseUrl(import.meta.env.VITE_API_BASE_URL),
  mcpUrl:
    readEnv(import.meta.env.VITE_MCP_URL) ||
    (normalizeBaseUrl(import.meta.env.VITE_API_BASE_URL)
      ? `${normalizeBaseUrl(import.meta.env.VITE_API_BASE_URL)}/mcp`
      : ""),
  authBaseUrl: normalizeBaseUrl(import.meta.env.VITE_AUTH_BASE_URL),
  simulatedLatencyMs: resolveSimulatedLatencyMs(import.meta.env.VITE_SIMULATED_LATENCY),
  buildId: __APP_BUILD_ID__,
};

function normalizeBaseUrl(value: string | undefined): string {
  return readEnv(value).replace(/\/+$/, "");
}

function resolveSimulatedLatencyMs(value: string | undefined): number | null {
  // 시뮬레이션 지연은 개발 도구다. 프로덕션 빌드에서는 어떤 값을 줘도 주입하지 않는다.
  if (!import.meta.env.DEV) {
    return null;
  }

  const raw = readEnv(value).toLowerCase();
  if (raw === "off" || raw === "0" || raw === "false") {
    return null;
  }

  // 숫자를 주면 그 값을 표준 지연(ms)으로 사용한다.
  if (raw !== "") {
    const parsed = Number(raw);
    if (Number.isFinite(parsed) && parsed >= 0) {
      return parsed;
    }
  }

  // 값이 없으면 개발 빌드에서 표준 round-trip 지연을 기본 적용한다.
  return STANDARD_LATENCY_MS;
}

function readEnv(value: string | undefined): string {
  return value?.trim() ?? "";
}
